import items from './items.json';
import config from './config.json';


export const data = {
   items: items,
   config: config,
};